import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { USER_BASE_PATH } from '../../../user/constants/userBasePath';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { deleteResetApplicationAssignUser } from '../../requests/deleteResetApplicationAssignUser';

export const useResetApplicationAssignUser = (definitionName: string) => {
  const queryClient = useQueryClient();
  const { constructDelete } = useRequestConstructor();

  const { mutateAsync: resetAssignUser, ...rest } = useMutation({
    mutationFn: (uuid: string) =>
      deleteResetApplicationAssignUser(constructDelete, uuid, definitionName),
    onSuccess: (_, uuid) => {
      queryClient.invalidateQueries({
        queryKey: [USER_BASE_PATH, 'assignees'],
      });
      queryClient.invalidateQueries({
        queryKey: [APPLICATION_BASE_PATH, uuid, 'assignments'],
      });
    },
  });

  return { resetAssignUser, ...rest };
};
